import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { EUrlShortenerAllowedScopes, OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services['url-shortener'],

      backendGeneration: 'nest',

      outputFilter(result) {
        const length = result?.generationParams?.length
        if (typeof length === 'string') {
          result.generationParams.length = parseInt(length, 10)
        }

        return result
      },

      find: {
        defaultFilter: {
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          scopes: [ EUrlShortenerAllowedScopes.full ],
          search: undefined,
          ownerId: undefined,
          createdAtPreset: undefined,
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        }
      },

      has: {
        tabs: false,
        clone: false,
        support: false
      },

      formClass: '',
      titlePath: 'fullUrl'
    })
  ]
}
